module.exports = "<p>\n  Sivua ei löytynyt!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// C:/DEV/saaristonsiirin/src/app/page-not-found/page-not-found.component.html
// module id = ../../../../../src/app/page-not-found/page-not-found.component.html
// module chunks = 1